import React, { useState } from "react";
import { Tabs, Tab } from "@material-ui/core";

import { TabbingStyle } from "./style";
import Consignments from "./consignments";
import TimeReport from "./time-report";
import PriceMatrix from "./price-matrix";
import TempTracking from "./temperature-tracking";
import JobHistory from "./job-history";

function Tabbing(props) {
	const classes = TabbingStyle();
	const [value, setValue] = useState(0);

	const handleChangeTab = (event, newValue) => {
		setValue(newValue);
	};
	function TabPanel(props) {
		const { children, value, index } = props;
		return (
			value === index && <div className="tab-pannel-wrapper"> {children} </div>
		);
	}

	return (
		<div className={classes.TabbingWrapper}>
			<div className="white-card tabbing-wrapper">
				<Tabs
					value={value}
					onChange={handleChangeTab}
					textColor="primary"
					variant="scrollable"
					scrollButtons="auto"
				>
					<Tab label={`Consignments`} />
					<Tab label="Run Sheet" />
					{props.historyHandoff?.length > 0 && <Tab label="Job History" />}

					{["Review Completed", "Completed"].includes(
						props.jobsData?.jobStatuses?.name
					) && <Tab label="Pricing" />}

					{
						props.jobsData?.isTkTracking ? (<Tab label="Temperature Tracking" />) : ""
					}
				</Tabs>
				<TabPanel value={value} index={0}>
					<Consignments jobsData={props.jobsData} getJobs={props.getJobs} />
				</TabPanel>
				<TabPanel
					value={value}
					index={1}
				>
					<TimeReport jobsData={props.jobsData} getJobs={props.getJobs} />
				</TabPanel>

				{props.historyHandoff?.length > 0 && (
					<TabPanel
						value={value}
						index={2}
					>
						<JobHistory historyHandoff={props.historyHandoff} />
					</TabPanel>
				)}

				{["Review Completed", "Completed"].includes(
					props.jobsData?.jobStatuses?.name
				) && (
						<TabPanel
							value={value}
							index={
								props.historyHandoff?.length > 0 ? 3 : 2
							}
						>
							<PriceMatrix jobsData={props.jobsData} getJobs={props.getJobs} />
						</TabPanel>
					)
				}
				{props.jobsData?.isTkTracking && (
					<TabPanel value={value}
						index={
							props.historyHandoff?.length > 0
								&& ["Review Completed", "Completed"].includes(
									props.jobsData?.jobStatuses?.name
								) ? 4 : props.historyHandoff?.length === 0
									&& !["Review Completed", "Completed"].includes(
										props.jobsData?.jobStatuses?.name
									) ? 2 : 3
						}
					>
						<TempTracking jobsData={props.jobsData} getJobs={props.getJobs} />
					</TabPanel>
				)}
			</div>
		</div>
	);
}
export default React.memo(Tabbing);
